import { Check } from "lucide-react";
import { DropdownMenu as M } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { surface } from "./foundation";
export const DropdownMenu = M.Root;
export const DropdownMenuTrigger = M.Trigger;
export const DropdownMenuGroup = M.Group;
export const DropdownMenuPortal = M.Portal;
export const DropdownMenuRadioGroup = M.RadioGroup;
export const DropdownMenuSeparator = surface(
  M.Separator,
  "dropdown-menu-separator",
  "my-1 border-t",
);
export const DropdownMenuLabel = surface(
  M.Label,
  "dropdown-menu-label",
  "px-2 py-1 text-xs text-muted-foreground",
);
export const DropdownMenuShortcut = surface(
  "span",
  "dropdown-menu-shortcut",
  "ml-auto text-xs text-muted-foreground",
);
export function DropdownMenuContent({
  className,
  sideOffset = 5,
  ...props
}: ComponentProps<typeof M.Content>) {
  return (
    <M.Portal>
      <M.Content
        {...props}
        sideOffset={sideOffset}
        className={cn("cyra-popup min-w-44 p-1", className)}
      />
    </M.Portal>
  );
}
export function DropdownMenuItem({
  className,
  inset: _inset,
  variant,
  ...props
}: ComponentProps<typeof M.Item> & { inset?: boolean; variant?: "default" | "destructive" }) {
  return (
    <M.Item
      {...props}
      className={cn("cyra-menu-item", variant === "destructive" && "text-destructive", className)}
    />
  );
}
export function DropdownMenuCheckboxItem({
  children,
  className,
  ...props
}: ComponentProps<typeof M.CheckboxItem>) {
  return (
    <M.CheckboxItem {...props} className={cn("cyra-menu-item", className)}>
      {children}
      <M.ItemIndicator className="ml-auto">
        <Check aria-hidden size={14} />
      </M.ItemIndicator>
    </M.CheckboxItem>
  );
}
export function DropdownMenuRadioItem({
  children,
  className,
  ...props
}: ComponentProps<typeof M.RadioItem>) {
  return (
    <M.RadioItem {...props} className={cn("cyra-menu-item", className)}>
      {children}
      <M.ItemIndicator className="ml-auto">
        <Check aria-hidden size={14} />
      </M.ItemIndicator>
    </M.RadioItem>
  );
}
